import { Injectable, inject } from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Observable, filter, takeUntil, timeout } from 'rxjs';
import { ConfigService } from '@services/config.service';
import { OnlineStateService } from '@services/online-state.service';
import { PageLoadService } from '@app/services/page-load.service';
import { MAIL_TYPE } from '@constants/app.constants';

@Injectable()
export class SupportRequestTimeoutInterceptor implements HttpInterceptor {
  private readonly config = inject(ConfigService);
  private readonly onlineState = inject(OnlineStateService);

  public intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    if (request.method !== 'POST') return next.handle(request);

    const baseUrl = this.config.urlBackEndApi.replace(/\/$/, '');
    const url = request.url.split(/[?#]/)[0].replace(/\/$/, '');
    const isSupportMail = url === `${baseUrl}/mail`
      && request.body instanceof FormData
      && request.body.get('type') === MAIL_TYPE.SUPPORT.toString();
    if (!isSupportMail && url !== `${baseUrl}/mail/createUnauthAsJson`) {
      return next.handle(request);
    }

    return next.handle(request.clone({reportProgress: true})).pipe(
      timeout({each: PageLoadService.REQUEST_TIMEOUT_MS}),
      takeUntil(this.onlineState.isOffline$.pipe(filter(isOffline => isOffline))),
    );
  }
}
